import React from 'react';
import { FormFieldProps } from '../FormField/FormField';
import {
  FormTextInputProps,
  FormTextInput,
} from '../FormTextInput/FormTextInput';
import { FormDropdown } from '../FormDropdown/FormDropdown';
import { FormCheckboxesGroup } from '../FormCheckboxesGroup/FormCheckboxesGroup';
import { FormRadioButtons } from '../FormRadioButtons/FormRadioButtons';
import {
  CHECKBOXES,
  PASSWORD_CONFIRMATION,
  DATE,
  DROPDOWN,
  EMAIL,
  NUMBER,
  PASSWORD,
  PHONE_NUMBER,
  RADIO_BUTTONS,
  TEXT,
  UNDEFINED,
  COUNTRY,
  MASTERCARD,
  FAVORITE_PLAYER,
  ONE_CLUB_FREE_TEXT,
  DROPDOWNS_GROUP,
  PP_DROPDOWN,
  DROPDOWN_WITH_OTHER,
  PASSWORD_WITH_CONFIRM_AND_MULTIPLE_VALIDATION,
  ATTACHMENT,
  HIDDEN_FIELD_WITH_VALUE,
  NUMBERED_CHECKBOXES,
  NUMBERED_CHECKBOXES_WITH_OTHER,
} from '../../constants/fieldTypes';
import FormPhoneField from '../FormPhoneField/FormPhoneField';
import CountryFormField from '../CountryFormField/CountryFormField';
import FavoritePlayerFormField from '../FavoritePlayerFormField/FavoritePlayerFormField';
import FormDateField, {
  FormDateFieldProps,
} from '../FormDateField/FormDateField';
import MastercardFormField from '../MastercardFormField/MastercardFormField';
import FreeText from '../FreeText/FreeText';
import { FormDropdownsGroup } from '../FormDropdownsGroup/FormDropdownsGroup';
import { FormDropdownPP } from '../FormDropdownPP/FormDropdownPP';
import FormDropdownWithOther from '../FormDropdownWithOther/FormDropdownWithOther';
import {
  FormPasswordWithMultipleValidation,
  FormPasswordWithMultipleValidationProps,
} from '../FormPasswordWithMultipleValidation/FormPasswordWithMultipleValidation';
import { FormFieldAttachment } from '../FormFieldAttachment/FormFieldAttachment';
import HiddenFieldWithValue from '../HiddenFieldWithValue/HiddenFieldWithValue';
import FormNumberedCheckboxesGroup from '../FormNumberedCheckboxesGroup/FormNumberedCheckboxesGroup';
import FormNumberedCheckboxesWithOther from '../FormNumberedCheckboxesWithOther/FormNumberedCheckboxesWithOther';

export type FormFieldTypes =
  | typeof TEXT
  | typeof EMAIL
  | typeof PASSWORD
  | typeof DROPDOWN
  | typeof RADIO_BUTTONS
  | typeof CHECKBOXES
  | typeof NUMBER
  | typeof PHONE_NUMBER
  | typeof PASSWORD_CONFIRMATION
  | typeof COUNTRY
  | typeof UNDEFINED
  | typeof DATE
  | typeof MASTERCARD
  | typeof FAVORITE_PLAYER
  | typeof ONE_CLUB_FREE_TEXT
  | typeof DROPDOWNS_GROUP
  | typeof PP_DROPDOWN
  | typeof DROPDOWN_WITH_OTHER
  | typeof PASSWORD_WITH_CONFIRM_AND_MULTIPLE_VALIDATION
  | typeof ATTACHMENT
  | typeof HIDDEN_FIELD_WITH_VALUE
  | typeof NUMBERED_CHECKBOXES
  | typeof NUMBERED_CHECKBOXES_WITH_OTHER;

export const formFieldsConfig: Record<
  FormFieldTypes,
  (fieldProps: FormFieldProps) => React.JSX.Element | undefined
> = {
  text: (fieldProps: FormTextInputProps) => {
    return <FormTextInput {...fieldProps} />;
  },
  email: (fieldProps: FormTextInputProps) => formFieldsConfig.text(fieldProps),
  password: (fieldProps: FormTextInputProps) =>
    formFieldsConfig.text(fieldProps),
  password_confirmation: (fieldProps: FormTextInputProps) => {
    return <FormTextInput {...fieldProps} fieldType={PASSWORD} />;
  },
  dropdown: (fieldProps: FormFieldProps) => {
    return <FormDropdown {...fieldProps} menuPlacement="bottom" />;
  },
  pp_dropdown: (fieldProps: FormFieldProps) => {
    return <FormDropdownPP {...fieldProps} menuPlacement="auto" />;
  },
  dropdowns_group: (fieldProps: FormFieldProps) => {
    return <FormDropdownsGroup {...fieldProps} />;
  },
  dropdown_with_other: (fieldProps: FormFieldProps) => {
    return <FormDropdownWithOther {...fieldProps} />;
  },
  radio_buttons: (fieldProps: FormFieldProps) => {
    return <FormRadioButtons {...fieldProps} />;
  },
  checkboxes: (fieldProps: FormFieldProps) => {
    return <FormCheckboxesGroup {...fieldProps} />;
  },
  numbered_checkboxes: (fieldProps: FormFieldProps) => {
    return <FormNumberedCheckboxesGroup {...fieldProps} />;
  },
  numbered_checkboxes_with_other: (fieldProps: FormFieldProps) => {
    return <FormNumberedCheckboxesWithOther {...fieldProps} />;
  },
  number: (fieldProps: FormFieldProps) => {
    return <FormTextInput {...fieldProps} />;
  },
  date: (fieldProps: FormDateFieldProps) => {
    return <FormDateField {...fieldProps} />;
  },
  phone_number: (fieldProps: FormFieldProps) => {
    return <FormPhoneField {...fieldProps} />;
  },
  country: (fieldProps: FormFieldProps) => {
    return <CountryFormField {...fieldProps} />;
  },
  mastercard: (fieldProps: FormFieldProps) => {
    return <MastercardFormField {...fieldProps} />;
  },
  favorite_player: (fieldProps: FormFieldProps) => {
    return <FavoritePlayerFormField {...fieldProps} />;
  },
  one_club_free_text: (fieldProps: FormFieldProps) => {
    return <FreeText {...fieldProps} />;
  },
  password_with_confirm_and_multiple_validation: (
    fieldProps: FormPasswordWithMultipleValidationProps,
  ) => {
    return <FormPasswordWithMultipleValidation {...fieldProps} />;
  },
  attachment: (fieldProps: FormFieldProps) => {
    return <FormFieldAttachment {...fieldProps} />;
  },
  hidden_field_with_value: (fieldProps: FormFieldProps) => {
    return <HiddenFieldWithValue {...fieldProps} />;
  },
  undefined: (...args: unknown[]) => undefined,
};
